import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { AxiosInstance } from 'axios';
import _ from 'lodash';

import { FlexDisplay } from '../../../Screens/Preferences/Preferences.styled';
import {
	ContainerSendCode,
	FormGroup,
	FormInput,
	LabelInput,
	LabelResend,
	LabelSendCode,
} from '../Preferences.component.styled';
import { FormInput as FormInputSignIn } from '../../SignIn/SignIn.styled';
import { Button } from '../../index';
import { IValue } from '../UserSetting.component';
import { ChangeNameType } from '../../../Screens/Preferences/Preferences.types';
import servicesRequest, {
	REQUEST_EDIT_PROFILE_URL,
} from '../../../Config/services.config';
import { ERROR_CODES } from '../../../Constants';
import { ErrorResponse } from '../../VerificationModal/VerificationModal.types';

const ChangeNameComponent = (props: ChangeNameType): React.JSX.Element => {
	const defaultFirstName = props.firstName;
	const defaultLastName = props.lastName;
	const { setIsChange, isChange } = props

	const [isLoading, setIsLoading] = useState(false);
	const [firstName, setFirstName] = useState(defaultFirstName);
	const [lastName, setLastName] = useState(defaultLastName);
	const [verificationCode, setVerificationCode] = useState('');
	const [countdown, setCountdown] = useState(0);
	const [eligibleRequestOTP, setEligibleRequestOTP] = useState(false);

	useEffect(() => {
		if (firstName === defaultFirstName && lastName === defaultLastName) {
			setIsChange(false);
		} else {
			setIsChange(true);
		}
	}, [firstName, lastName]);

	const handleSubmit = async () => {
		setIsLoading(true);
		try {
			const request: AxiosInstance = servicesRequest();
			await request.put(REQUEST_EDIT_PROFILE_URL, {
				field: 'name',
				token: verificationCode,
				first_name: firstName,
				last_name: lastName,
				email: props.email,
			});
			props.setEditMode('');
			props.changeShouldReload();

			toast.success('Profile successfully edited.');
		} catch (error) {
			const err = error as ErrorResponse;
			const statusCode = _.get(err, 'response.data.status_code');
			const message = _.get(err, 'response.data.message');

			if (statusCode === ERROR_CODES.VERIFICATION_ERROR) {
				toast.error(message);
			} else {
				toast.error('Something went wrong. Please try agin.');
			}
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		let intervalId: string | number | NodeJS.Timeout | undefined;

		if (countdown > 0) {
			intervalId = setInterval(() => {
				setCountdown(prevCountdown => prevCountdown - 1);
			}, 1000);
		} else {
			setEligibleRequestOTP(false);
		}

		return () => {
			clearInterval(intervalId);
		};
	}, [countdown]);

	const handleRequestOTP = async () => {
		setCountdown(60);
		setEligibleRequestOTP(true);

		try {
			const request: AxiosInstance = servicesRequest();
			await request.post(REQUEST_EDIT_PROFILE_URL, {
				field: 'name',
			});

			toast.success('Success requesting OTP. Please check your email.');
		} catch (error) {
			toast.error('Error requesting OTP. Please try again.');
		}
	};

	return (
		<div className="mb-1">
			<FlexDisplay>
				<FormGroup className="mb-1 w-50">
					<LabelInput>First Name</LabelInput>
					<FormInput
						type="text"
						placeholder="First Name"
						value={firstName}
						onChange={(event: IValue) => setFirstName(event.target.value)}
					/>
				</FormGroup>

				<FormGroup className="mb-1 w-50">
					<LabelInput>Last Name</LabelInput>
					<FormInput
						type="text"
						placeholder="Last Name"
						value={lastName}
						onChange={(event: IValue) => setLastName(event.target.value)}
					/>
				</FormGroup>
			</FlexDisplay>

			{isChange && (
				<React.Fragment>
					<ContainerSendCode className="w-50 mb-2">
						<div className="w-50">
							<FormInputSignIn
								type="text"
								placeholder="Verification Code"
								value={verificationCode}
								onChange={(event: IValue) =>
									setVerificationCode(event.target.value)
								}
							/>
						</div>

						<div>
							{eligibleRequestOTP ? (
								<LabelResend>{`resend code in ${countdown}s`}</LabelResend>
							) : (
								<LabelSendCode onClick={handleRequestOTP}>
									send code
								</LabelSendCode>
							)}
						</div>
					</ContainerSendCode>
					<Button
						label="Verify and save"
						isLoading={isLoading}
						onClick={handleSubmit}
						width="25%"
						mobileWidth="50%"
						disabled={!isChange || verificationCode === ''}
					/>
				</React.Fragment>
			)}
		</div>
	);
};

export default ChangeNameComponent;
